/**
 * Výčet typů klientů pro komunikaci s webovým API.
 * @includeToDoc
 */
export enum ClientType {
    menu = "menu",
    user = "user",
    notifications = "notifications",
    tasks = "tasks",
    authentication = "authentication",
    userSettings = "userSettings",
    localizations = "localizations",
    culture = "culture",
    dataReader = "dataReader",
    document = "document",
    dataEvents = "dataEvents",
    modelDescriptions = "modelDescriptions",
    context = "context",
    exportImport = "exportimport",
}
